import config from '@app/config'
import ws from '@api/webservice'

const api = {
  getAllPlaces: (siteId: string): Promise<Places> => ws(`${config.ws.visioglobe.places}?siteId=${siteId}`, 'GET'),
  getSiteInfo: (): Promise<SiteInfo> => ws(`${config.ws.visioglobe.siteInfo}`, 'GET'),
}

export default api
